import { render, staticRenderFns } from "./TabletMain.vue?vue&type=template&id=5cea2122&scoped=true&"
import script from "./TabletMain.vue?vue&type=script&lang=js&"
export * from "./TabletMain.vue?vue&type=script&lang=js&"
import style0 from "./TabletMain.vue?vue&type=style&index=0&id=5cea2122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea2122",
  null
  
)

export default component.exports